import { render, staticRenderFns } from "./infoIcon.vue?vue&type=template&id=f87b60cc"
import script from "./infoIcon.vue?vue&type=script&lang=js"
export * from "./infoIcon.vue?vue&type=script&lang=js"
import style0 from "./infoIcon.vue?vue&type=style&index=0&id=f87b60cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports